import { defined } from './../../utils';
import { Cursors } from './../../constants';
import { noMeta } from './noMeta';
export class SelectionTool {
    constructor(toolService) {
        this.toolService = toolService;
    }
    tryActivate(_p, meta) {
        const toolService = this.toolService;
        const selectable = toolService.diagram.options.selectable;
        let enabled = selectable && selectable.multiple !== false;
        if (enabled) {
            if (selectable.key && selectable.key !== 'none') {
                enabled = meta[selectable.key + 'Key'];
            }
            else {
                enabled = noMeta(meta);
            }
        }
        return enabled && !defined(toolService.hoveredItem) && !defined(toolService.hoveredAdorner);
    }
    start(p) {
        const diagram = this.toolService.diagram;
        diagram.deselect();
        diagram.selector.start(p);
    }
    move(p) {
        const diagram = this.toolService.diagram;
        diagram.selector.move(p);
    }
    end(_p, meta) {
        const diagram = this.toolService.diagram, hoveredItem = this.toolService.hoveredItem;
        const rect = diagram.selector.bounds();
        if ((!hoveredItem || !hoveredItem.isSelected) && !meta.ctrlKey) {
            diagram.deselect();
        }
        if (!rect.isEmpty()) {
            diagram.selectArea(rect);
        }
        diagram.selector.end();
    }
    getCursor() {
        return Cursors.arrow;
    }
}
